<template>
  <div v-b-tooltip.hover :title="tooltip[hook]">
    {{ label[hook] }}
    <b-button variant="danger" size="sm"
      @click="$emit('remove')">
      <b-icon icon="x" />
    </b-button>
  </div>
</template>

<script>
import { 
 hookLabel, 
 hookTooltip
} from './mixin-cmd'
export default {
  props: {
    value: Object,
    hook: String
  },
  computed: {
    label () { return hookLabel },
    tooltip () { return hookTooltip }
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  watch: {
    value (v) {
      this.innerValue = v
    },
    'innerValue.args' () {
      this.$emit('input', this.innerValue)
    }
  }
}
</script>

<style>

</style>